import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation, inject } from '@angular/core';
import { ClixelService, TrixelInteraction } from '../domain/services/clixel.service';

@Component({
  selector: 'rma-trixel',
  templateUrl: './trixel.component.html',
  styleUrls: ['./trixel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [],
})
export class TrixelComponent implements OnChanges {
  private readonly clixelService = inject(ClixelService);

  @Input() trixelSourceCategory?: string;
  @Input() trixelInteraction?: TrixelInteraction;
  @Input() trixelReferringSourceCategory?: string;
  @Input() trixelImgUrl?: string | null;

  public url?: string;

  ngOnChanges(_: SimpleChanges): void {
    if (this.trixelImgUrl) {
      this.url = this.clixelService.formatTrixelUrl(
        this.trixelImgUrl,
        this.trixelSourceCategory,
        this.trixelInteraction,
        this.trixelReferringSourceCategory,
      );
    } else {
      this.url = undefined;
    }
  }
}
